
$models.users = {
	
	getItem : function() { },
	
	getList : function($params, $callback) {
		if ($models.users.currentGetListAjaxRequest) {
			$models.users.currentGetListAjaxRequest.abort();
		}
		$models.users.currentGetListAjaxRequest = $models.all.getDataFromAPI('users.json', $params, function($data) {
			jQuery.each($data.users, function($key, $user) {
				$user.display_name = '';
				if ($user.first_name) { $user.display_name += $user.first_name + ' '; }
				if ($user.last_name)  { $user.display_name += $user.last_name; }
				$data.users[$key] = $user;
			});
			$callback($data);
		}, 'Unable to retrieve list of users.  You might not have permission to do so.');
	},
	
	getListWithOffset : function($params, $callback) {
		$params = ($params || {});
		$models.users.getList($params, $callback);
	},
	
	getSize : function($callback) {
		// no count.json exists... simply proxy the users.json for now!
		$models.users.getList({}, function($data) {
			$callback($data.result_count);
		});
	},
	
	getAdmins : function($callback) {
		$models.users.getList({}, function($data) {
			var $teamAdmins = [];
			jQuery.each($data.users, function($key, $user) {
				if ($user.admin) {
					$teamAdmins.push($user);
				}
			});
			$callback($teamAdmins);
		});
	},
	
	getMyData : function($callback) {
		$models.all.getDataFromAPI('users/me.json', '', $callback);
	},
	
	setMyData : function($formData, $callback) {
		$models.all.getDataFromAPI('users/me.json', $formData, $callback, function($error) {
			$soupmail.notification.error($error.error, 'An error occurred whilst saving changes to your user profile');
		}, 'PUT');
	},
	
	setUserAsAdmin : function($userid, $value, $callback) {
		$models.all.getDataFromAPI('users/'+$userid+'.json', {user: {admin: $value}}, $callback, function($error) {
			$soupmail.notification.error($error.error, 'An error occurred whilst saving admin permissions for a user account');
		}, 'PUT');
	},
	
	deleteItem : function($userid, $callback) {
		$models.all.getDataFromAPI('users/'+$userid+'.json', {}, $callback, function($error) {
			$soupmail.notification.error($error.error, 'An error occurred whilst removing your account');
		}, 'DELETE');
	},
	
	newItem : function($formData, $callbackSuccess, $callbackFailure) {
		$models.all.getDataFromAPI('users.json', $formData, $callbackSuccess, $callbackFailure, 'POST');
	},
	
	activateItem : function($formData, $callbackSuccess, $callbackFailure) {
		$models.all.getDataFromAPI('users/activate.json', $formData, $callbackSuccess, $callbackFailure, 'PUT', 'token');
	},
	
	reactivateItem : function($formData, $callback) {
		$models.all.getDataFromAPI('users/resend_activation_email.json', $formData, $callback, function($error) {
			$soupmail.notification.error($error.error, 'An error occurred whilst submitting your request');
		}, 'POST');
	},
	
	getResetPassword : function($formData, $callback) {
		$models.all.getDataFromAPI('users/send_password_reset.json', $formData, $callback, function($error) {
			$soupmail.notification.error($error.error, 'An error occurred whilst submitting your password reset');
		}, 'POST', 'token');
	},
	
	setResetPassword : function($formData, $callback) {
		$models.all.getDataFromAPI('users/reset_password.json', $formData, $callback, function($error) {
			$soupmail.notification.error($error.error, 'An error occurred whilst saving your new password');
		}, 'PUT', 'token');
	},
	
	isAjaxRequestInProgress : function() {
		if (!$models.users.currentGetListAjaxRequest) { return false; }
		if ($models.users.currentGetListAjaxRequest.status > 100) { return false; }
		return true;
	}
	
};



// WEBPACK FOOTER //
// ./src/js/models/users.js